import React from "react";
import classnames from "classnames";
import { updateFn } from "../shared/events";

export const ToggleSwitch = ({ variant = "normal", ...props }) => {
    const classes = classnames({
        "-small": variant === "small",
        "-disabled": props.hasDisabledStyles,
    });

    return (
        <label className={`switch ${classes}`}>
            <input
                type="checkbox"
                data-testid={props.testid}
                name={props.name}
                checked={props.value}
                value={props.value}
                onChange={updateFn(props.updateOnChange)}
                disabled={props.disabled}
            />
            <span className={`slider round ${classes}`} />
        </label>
    );
};
